import { useField } from 'formik';
import * as styles from './styles/roundedText.module.scss';
import { generateClassName } from '@klv/shared/utils/functions';
import type { ITextInput } from '../types';

const RoundedTextInput = ({
  errorClassName,
  placeholder = '',
  autocomplete,
  autofocus,
  description = '',
  backgroundColor = 'dark',
  submitted = true,
  ...props
}: ITextInput) => {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input>. We can use field meta to show an error
  // message if the field is invalid and it has been touched (i.e. visited)
  const [field, meta] = useField(props);

  return (
    <div className={styles[backgroundColor]}>
      {description.length > 0 && (
        <div className={generateClassName([styles.description, styles[backgroundColor]])}>
          {description}
        </div>
      )}
      <div className={styles.floatingWrapper}>
        <input
          className={generateClassName([styles.input, styles[backgroundColor]])}
          placeholder={placeholder}
          autoComplete={autocomplete || undefined}
          autoFocus={autofocus}
          {...field}
          {...props}
        />
      </div>
      {submitted && meta.touched && meta.error && (
        <div className={generateClassName([styles.error, errorClassName])}>{meta.error}</div>
      )}
    </div>
  );
};

export default RoundedTextInput;

